<div class="hp">
  <!-- ===================== Lo inactivo momentanemaente ===================== -->
  <!-- ===================== HISTORIA: línea de tiempo interactiva ===================== -->
  <section class="hp-historia" data-screen-label="Historia" *ngIf="false">
    <!-- decorative blobs / spiral -->
    <span aria-hidden="true" class="hp-blob hp-blob--red"></span>
    <span aria-hidden="true" class="hp-blob hp-blob--navy"></span>
    <!-- <span aria-hidden="true" class="hp-spiral">
      <svg viewBox="0 0 80 80" width="80" height="80">
        <path
          d="M40 40 m-30 0 a30 30 0 1 0 60 0 a30 30 0 1 0 -60 0 M40 40 m-20 0 a20 20 0 1 1 40 0 a20 20 0 1 1 -40 0 M40 40 m-10 0 a10 10 0 1 0 20 0"
          stroke="#9c2a2a" stroke-width="1.5" fill="none" opacity="0.5" />
      </svg>
    </span> -->

    <div class="hp-container hp-historia__container">
      <header class="hp-historia__header">
        <h2 class="hp-historia__h2">Nuestra <span class="hp-accent">Historia</span></h2>
        <span class="hp-eyebrow">Línea de tiempo · 1856 — 2026</span>
        <p class="hp-historia__lede">
          Casi un siglo y medio acompañando familias. Un recorrido de fe, educación y comunidad
          que sigue escribiéndose cada día.
        </p>
      </header>

      <!-- Year chip rail (horizontal scroller) -->
      <div
        #rail
        class="hp-rail"
        tabindex="0"
        role="tablist"
        aria-label="Hitos por año"
        (keydown)="onRailKey($event)">
        <div class="hp-rail__track"></div>
        <button
          *ngFor="let t of timeline; let i = index"
          class="hp-chip"
          [class.hp-chip--active]="i === activeIndex"
          [class.hp-chip--past]="i < activeIndex"
          [attr.data-idx]="i"
          role="tab"
          [attr.aria-selected]="i === activeIndex"
          (click)="goTo(i)">
          <span class="hp-chip__dot">
            <span class="hp-chip__dot-inner" [style.background]="chipDotColor(i)"></span>
          </span>
          <span class="hp-chip__year">{{ t.year }}</span>
          <span class="hp-chip__short">{{ t.short }}</span>
        </button>
      </div>

      <!-- Active card -->
      <article class="hp-card" [attr.data-year]="historiaItem.year">
        <div class="hp-card__left">
          <div class="hp-photo" [ngStyle]="placeholderStyle(historiaItem.tone)">
            <img
              *ngIf="historiaItem.image"
              class="hp-photo__img"
              [src]="historiaItem.image"
              [alt]="historiaItem.title" />
            <span class="hp-photo__label" *ngIf="!historiaItem.image" [style.color]="placeholderInk(historiaItem.tone)">
              {{ historiaItem.placeholder }}
            </span>
         
          </div>
          <div class="hp-card__caption">
            <span class="hp-card__meta">Archivo · Instituto San José</span>
          </div>
        </div>

        <div class="hp-card__right">
          <div class="hp-card__bigYear">{{ historiaItem.year }}</div>
          <h3 class="hp-card__title">{{ historiaItem.title }}</h3>
          <p class="hp-card__body" [innerHTML]="historiaItem.body | safeHtml"></p>

          <div class="hp-card__controls">
            <button
              class="hp-navBtn"
              [class.hp-navBtn--disabled]="activeIndex === 0"
              [disabled]="activeIndex === 0"
              (click)="goTo(activeIndex - 1)"
              aria-label="Hito anterior">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Anterior
            </button>
            <div class="hp-counter">
              <strong>{{ pad2(activeIndex + 1) }}</strong>
              <span class="hp-counter__total"> / {{ pad2(timeline.length) }}</span>
            </div>
            <button
              class="hp-navBtn hp-navBtn--primary"
              [class.hp-navBtn--disabled]="activeIndex === timeline.length - 1"
              [disabled]="activeIndex === timeline.length - 1"
              (click)="goTo(activeIndex + 1)"
              aria-label="Hito siguiente">
              Siguiente
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      </article>

      <!-- Stats strip -->
      <div class="hp-historia__stats">
        <div class="hp-stat" *ngFor="let s of historiaStats">
          <div class="hp-stat__n">{{ s.n }}</div>
          <div class="hp-stat__l">{{ s.l }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ===================== PRESENCIA: red / mapa esquemático ===================== -->
  <section class="hp-presencia" data-screen-label="Presencia Adoratriz">
    <div class="hp-container">
      <header class="hp-presencia__header">
        <h2 class="hp-presencia__h2" [innerHTML]="presenciaTitle | safeHtml"></h2>
        <p class="hp-presencia__lede">{{ presenciaSubtitle }}</p>
      </header>

      <!-- tabs from similar_institutions.items -->
      <div class="hp-tabs" role="tablist" *ngIf="presenciaItems.length">
        <button
          *ngFor="let it of presenciaItems; let i = index"
          class="hp-tab"
          [class.hp-tab--active]="i === activeItemIndex"
          role="tab"
          [attr.aria-selected]="i === activeItemIndex"
          (click)="setItem(i)">
          <span class="hp-tab__label">{{ it.item }}</span>
          <span class="hp-tab__sub">{{ it.subitem }}</span>
        </button>
      </div>

      <!-- main grid: copy + image of the active item -->
      <div class="hp-presencia__grid" *ngIf="activeItem as item">
        <div class="hp-presencia__copy">
          <h3 class="hp-presencia__scopeTitle">{{ item.title }}</h3>
          <p class="hp-presencia__scopeBody">{{ item.description }}</p>
        </div>

        <div class="hp-presencia__media">
          <img
            *ngIf="item.image"
            class="hp-presencia__img"
            [src]="item.image"
            [alt]="item.title"
            onError="this.src='assets/images/logo-dark.png'"
            loading="lazy"
            decoding="async" />
        </div>
      </div>

      <!-- stats from similar_institutions.cards -->
      <div class="hp-presencia__stats" *ngIf="presenciaCards.length">
        <div class="hp-pstat" *ngFor="let c of presenciaCards">
          <div class="hp-pstat__n">{{ c.title }}</div>
          <div class="hp-pstat__l">{{ c.subtitle }}</div>
        </div>
      </div>
    </div>
  </section>
</div>
